import { Component, inject, OnInit } from '@angular/core';
import { PageErrorGlobalPresenter } from './ui-commons/page-error-global.presenter';
import { NavigationStart, Router } from '@angular/router';
import { take } from 'rxjs';
import { UICardContainerComponent } from "../../../../shared/ui-commons/ui-card-page/ui-card-page.components";
import { LocationAssetsPipe } from "@utils/pipes/location-assets.pipe";
import { CookiesDetectionService } from '../../services/cookies-detection-service';

@Component({
  selector: 'cv-page-error-global',
  templateUrl: './page-error-global.component.html',
  styleUrls: ['./page-error-global.component.scss'],
  imports: [
    UICardContainerComponent,
    LocationAssetsPipe
  ]
})
export class PageErrorGlobalComponent implements OnInit {
  pegp = new PageErrorGlobalPresenter;

  private readonly router = inject(Router);
  public cookieService = inject(CookiesDetectionService);

  ngOnInit(): void {
    // Bloquea la navegación del usuario
    this.router.events
      .pipe(
        take(1)
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.router.navigate(['/error']);
        }
      });
  }

}
